export default [
    {
        path: 'relatorio-entrada',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-relatorio-entrada' */
            '@/views/almoxarifado/relatorio-entrada/Index'
        ),
        redirect: 'relatorio-entrada/index',
        children: [
            {
                name: 'almoxarifado-relatorio-entrada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-relatorio-entrada' */
                    '@/views/almoxarifado/relatorio-entrada/List.vue'
                ),
            },
        ],
    },
]
